module.exports = __webpack_public_path__ + "static/media/logo-model-s.7d58a556.svg";